
export const LoadingPlaces = () => {
  return (
    <div className='alert alert-primary mt-2 text-center'>
        <h6>Searching... places </h6>
        <p>Loading...</p>
    </div>
  )
}
